export const HYDRATION_STANDARD_SCROLL_BUFFER = 50;
export const HYDRATION_EARLY_DELAY = 5;
export const HYDRATION_STANDARD_DELAY = 1000;
